module.exports = __webpack_public_path__ + "img/icon_emil.b6cf8717.png";